import { breakpoints } from '../settings.js';

function improveSearch() {
    const headerSearchToggleEl = document.querySelector('.c-header-main__nav__top .search-toggle');
    const headerSearchInputEl = document.querySelector('.c-header-main__nav__top input.form-search');
    const headerNavTopEl = document.querySelector('.c-header-main__nav__top');
    const searchOverlay = document.querySelector('.c-search-page-overlay');

    const megaMenuEl = document.querySelector('.navbar-we-mega-menu.navbar');
    const megaMenuToggleEl = document.querySelector('.navbar-toggle')
    // we-mobile-megamenu-active

    if (headerNavTopEl && headerSearchToggleEl && headerSearchInputEl) {
        headerSearchToggleEl.addEventListener('click', () => {
            if (headerNavTopEl.classList.contains('show-search')) {
                headerNavTopEl.classList.remove('show-search');

                // Show megamenu
                megaMenuEl.classList.remove('hide-due-to-search');
                megaMenuToggleEl.classList.remove('hide-due-to-search');

                if(window.innerWidth >= breakpoints.lg) {
                    searchOverlay.classList.remove('show');
                }

                window.setTimeout(() => {
                    headerSearchInputEl.blur();
                }, 100);

            } else {
                headerNavTopEl.classList.add('show-search');

                // Hide megamenu
                megaMenuEl.classList.add('hide-due-to-search');
                megaMenuToggleEl.classList.add('hide-due-to-search');

                if(window.innerWidth >= breakpoints.lg) {
                    searchOverlay.classList.add('show');
                }

                window.setTimeout( () => {
                    headerSearchInputEl.focus();
                }, 100);

            }
        });
    }

    // Hide mobile search if click on megaMenu toggle
    megaMenuToggleEl.addEventListener('click', () => {
        if (headerNavTopEl.classList.contains('show-mobile-menu')) {
            headerNavTopEl.classList.remove('show-mobile-menu');
            headerSearchToggleEl.classList.remove('hide-due-to-menu');
            // headerNavTopEl.classList.add('show-search');
        } else {
            headerNavTopEl.classList.add('show-mobile-menu');
            headerSearchToggleEl.classList.add('hide-due-to-menu');
            if (headerNavTopEl.classList.contains('show-search')) {
                headerNavTopEl.classList.remove('show-search');
            }
        }

    });
}



export { improveSearch };
